"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiClientAuthMiddleware = void 0;
var axios_1 = __importDefault(require("axios"));
var api_1 = require("../api");
var AuthTokenService_1 = __importDefault(require("./AuthTokenService"));
var api_client_1 = require("../api/api-client");
var refreshHandle;
var isRefreshing = false;
var failedQueue = [];
var refreshTokens = function (refreshToken) {
    return axios_1.default.post("".concat(process.env.INTERNAL_API_URL || api_client_1.BASE_NAME, "/").concat(api_1.USER_API_URLS.REFRESH), {
        refresh: refreshToken
    }).then(function (response) { return response.data.tokens; });
};
var processQueue = function (error, token) {
    failedQueue.forEach(function (prom) {
        if (error) {
            prom.reject(error);
        }
        else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};
var apiClientAuthMiddleware = function (apiClient) {
    var requestHandler = function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var access, refresh;
        return __generator(this, function (_a) {
            access = AuthTokenService_1.default.getToken('access');
            refresh = AuthTokenService_1.default.getToken('refresh');
            if (access) {
                config.headers = __assign(__assign({}, config.headers), { Authorization: access });
            }
            if (!access && refresh) {
                if (!refreshHandle) {
                    refreshHandle = refreshTokens(refresh)
                        .then(function (tokens) {
                        refreshHandle = null;
                        if (!(tokens === null || tokens === void 0 ? void 0 : tokens.refresh) || !tokens.access) {
                            throw new Error('Error refreshing tokens.');
                        }
                        return __assign({}, tokens);
                    });
                }
                return [2 /*return*/, refreshHandle
                        .then(function (tokens) {
                        AuthTokenService_1.default.setToken('refresh', tokens.refresh);
                        AuthTokenService_1.default.setToken('access', tokens.access);
                        config.headers = __assign(__assign({}, config.headers), { Authorization: tokens.access });
                        return config;
                    })
                        .catch(function () {
                        AuthTokenService_1.default.removeToken('refresh');
                        AuthTokenService_1.default.removeToken('access');
                        window.location.reload();
                        return config;
                    })];
            }
            return [2 /*return*/, config];
        });
    }); };
    var responseFailureHandler = function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var originalRequest, refresh_1;
        var _a, _b;
        return __generator(this, function (_c) {
            originalRequest = error.config;
            if ((((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 || ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 403) &&
                !originalRequest._retry) {
                if (isRefreshing) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            failedQueue.push({ resolve: resolve, reject: reject });
                        })
                            .then(function (token) {
                            // @ts-ignore
                            originalRequest.headers = __assign(__assign({}, originalRequest.headers), { Authorization: token });
                            return apiClient(originalRequest);
                        })
                            .catch(function (err) {
                            return Promise.reject(err);
                        })];
                }
                originalRequest._retry = true;
                isRefreshing = true;
                refresh_1 = AuthTokenService_1.default.getToken('refresh');
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        api_1.UserAPI.refresh({ refresh: refresh_1 })
                            .then(function (_a) {
                            var _b;
                            var data = _a.data;
                            if ((_b = data.responseMeta) === null || _b === void 0 ? void 0 : _b.error)
                                throw new Error('Error refresing tokens');
                            var _c = data.tokens, access = _c.access, refresh = _c.refresh;
                            AuthTokenService_1.default.setToken('access', access);
                            AuthTokenService_1.default.setToken('refresh', refresh);
                            originalRequest.headers = __assign(__assign({}, originalRequest.headers), { Authorization: access });
                            processQueue(null, access);
                            resolve(apiClient(originalRequest));
                        })
                            .catch(function (err) {
                            AuthTokenService_1.default.removeToken('access');
                            AuthTokenService_1.default.removeToken('refresh');
                            if (typeof window !== 'undefined') {
                                window.location.reload();
                            }
                            processQueue(err);
                            reject(err);
                        })
                            .finally(function () {
                            isRefreshing = false;
                        });
                    })];
            }
            return [2 /*return*/, Promise.reject(error)];
        });
    }); };
    if (typeof window !== 'undefined') {
        apiClient.interceptors.request.use(requestHandler);
        apiClient.interceptors.response.use(undefined, responseFailureHandler);
    }
    return apiClient;
};
exports.apiClientAuthMiddleware = apiClientAuthMiddleware;
exports.default = exports.apiClientAuthMiddleware;
